import { ScreenType } from '@/helpers/enums';

export const SLIDE_GAP = 16;
export const MOBILE_SLIDE_GAP = 8;
export const MOBILE_SLIDE_WIDTH = 232;

const SLIDES_PER_VIEW: Partial<Record<ScreenType, number>> = {
  [ScreenType.BASE]: 1.2,
  [ScreenType.SM]: 2,
  [ScreenType.MD]: 3,
  [ScreenType.LG]: 4,
  [ScreenType.XL]: 4,
  [ScreenType.XXL]: 5,
};

export const getSlidesPerView = (screenType: ScreenType) => {
  for (let type = screenType; type >= ScreenType.BASE; type--) {
    const perView = SLIDES_PER_VIEW[type as ScreenType];
    if (perView) return perView;
  }

  return 1;
};
